module.exports = __webpack_public_path__ + "assets/img/ZTS-CPS70-M.5061100a.png";